import { createSlice } from '@reduxjs/toolkit'

const initialState = {

    getAdmitCardLoading: false,
    getAdmitCardSuccess: null,
    getAdmitCardError: '',

    createAdmitCardLoading: false,
    createAdmitCardSuccess: {},
    createAdmitCardError: '',

    examPaperByCourseIdLoading: false,
    examPaperByCourseIdSuccess: {},
    examPaperByCourseIdError: "",

    examCenterByCourseIdLoading: false,
    examCenterByCourseIdSuccess: {},
    examCenterByCourseIdError: "",

    studentRegisterListLoading: false,
    studentRegisterListSuccess: {},
    studentRegisterListError: "",

    studentExamPaperListLoading: false,
    studentExamPaperListSuccess: {},
    studentExamPaperListError: "",

    admitCardByCourseIdLoading: false,
    admitCardByCourseIdSuccess: {},
    admitCardByCourseIdError: "",
    
}

export const admitCardSlice = createSlice({
    name: 'admitCard',
    initialState, 
    reducers: {
        setGetAdmitCardLoading: (state) => {
            state.getAdmitCardLoading = true;
            state.getAdmitCardSuccess = {};
            state.getAdmitCardError = '';
        },
        setGetAdmitCardSuccess: (state, action) => {
            state.getAdmitCardLoading = false;
            state.getAdmitCardSuccess = action.payload;
            state.getAdmitCardError = '';
        },
        setGetAdmitCardError: (state, action) => {
            state.getAdmitCardLoading = false;
            state.getAdmitCardSuccess = {};
            state.getAdmitCardError = action.payload;
        },
        setCreateAdmitCardLoading: (state) => {
            state.createAdmitCardLoading = true;
            state.createAdmitCardSuccess = {};
            state.createAdmitCardError = '';
        },
        setCreateAdmitCardSuccess: (state, action) => {
            state.createAdmitCardLoading = false;
            state.createAdmitCardSuccess = action.payload;
            state.createAdmitCardError = '';
        },
        setCreateAdmitCardError: (state, action) => {
            state.createAdmitCardLoading = false;
            state.createAdmitCardSuccess = {};
            state.createAdmitCardError = action.payload;
        },
        setExamPaperByCourseIdLoading: (state) => {
            state.examPaperByCourseIdLoading= true;
            state.examPaperByCourseIdSuccess= {};
            state.examPaperByCourseIdError= "";
        },
        setExamPaperByCourseIdSuccess: (state, action) => {
            state.examPaperByCourseIdLoading = false;
            state.examPaperByCourseIdSuccess = action.payload;
            state.examPaperByCourseIdError = '';
        },
        setExamPaperByCourseIdError: (state, action) => {
            state.examPaperByCourseIdLoading = false;
            state.examPaperByCourseIdSuccess = {};
            state.examPaperByCourseIdError = action.payload;
        },
        setAdmitCardByCourseIdLoading: (state) => {
            state.admitCardByCourseIdLoading= true;
            state.admitCardByCourseIdSuccess= {};
            state.admitCardByCourseIdError= "";
        },
        setAdmitCardByCourseIdSuccess: (state, action) => {
            state.admitCardByCourseIdLoading = false;
            state.admitCardByCourseIdSuccess = action.payload;
            state.admitCardByCourseIdError = '';
        },
        setAdmitCardByCourseIdError: (state, action) => {
            state.admitCardByCourseIdLoading = false;
            state.admitCardByCourseIdSuccess = {};
            state.admitCardByCourseIdError = action.payload;
        },
        resetDetails: (state) => {
            state.getAdmitCardSuccess = {};
            state.createAdmitCardSuccess = {};
        },
        setExamCenterByCourseIdLoading: (state) => {
            state.examCenterByCourseIdLoading= true;
            state.examCenterByCourseIdSuccess= {};
            state.examCenterByCourseIdError= "";
        },
        setExamCenterByCourseIdSuccess: (state, action) => {
            state.examCenterByCourseIdLoading = false;
            state.examCenterByCourseIdSuccess = action.payload;
            state.examCenterByCourseIdError = '';
        },
        setExamCenterByCourseIdError: (state, action) => {
            state.examCenterByCourseIdLoading = false;
            state.examCenterByCourseIdSuccess = {};
            state.examCenterByCourseIdError = action.payload;
        },
        setStudentRegisterListLoading: (state) => {
            state.studentRegisterListLoading = true;
            state.studentRegisterListSuccess = {};
            state.studentRegisterListError = "";
        },
        setStudentRegisterListSuccess: (state, action) => {
            state.studentRegisterListLoading = false;
            state.studentRegisterListSuccess = action.payload;
            state.studentRegisterListError = "";
        },
        setStudentRegisterListError: (state, action) => {
            state.studentRegisterListLoading = false;
            state.studentRegisterListSuccess = {};
            state.studentRegisterListError = action.payload;
        },

        setStudentExamPaperListLoading: (state) => {
            state.studentExamPaperListLoading= true;
            state.studentExamPaperListSuccess= {};
            state.studentExamPaperListError= "";
        },
        setStudentExamPaperListSuccess: (state, action) => {
            state.studentExamPaperListLoading = false;
            state.studentExamPaperListSuccess = action.payload;
            state.studentExamPaperListError = '';
        },
        setStudentExamPaperListError: (state, action) => {
            state.studentExamPaperListLoading = false;
            state.studentExamPaperListSuccess = {};
            state.studentExamPaperListError = action.payload;
        },
    }
})

export const { setGetAdmitCardLoading, setGetAdmitCardSuccess, setGetAdmitCardError, 
    setCreateAdmitCardLoading, setCreateAdmitCardSuccess, setCreateAdmitCardError,
    setExamPaperByCourseIdLoading, setExamPaperByCourseIdSuccess, setExamPaperByCourseIdError,
    setAdmitCardByCourseIdLoading, setAdmitCardByCourseIdSuccess, setAdmitCardByCourseIdError,
    setExamCenterByCourseIdLoading, setExamCenterByCourseIdSuccess, setExamCenterByCourseIdError,
    setStudentRegisterListLoading, setStudentRegisterListSuccess, setStudentRegisterListError,
    setStudentExamPaperListLoading, setStudentExamPaperListSuccess, setStudentExamPaperListError,
    resetDetails
} = admitCardSlice.actions;


export default admitCardSlice.reducer;